import { render, staticRenderFns } from "./RoleIntegration.vue?vue&type=template&id=329002b0&"
import script from "./RoleIntegration.vue?vue&type=script&lang=js&"
export * from "./RoleIntegration.vue?vue&type=script&lang=js&"
import style0 from "./RoleIntegration.vue?vue&type=style&index=0&id=329002b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports